<div class="px-4 py-4 sm:px-6">
	<ng-content />
</div>
